import React from 'react'
import { Picker } from './Picker'
import { Shortcuts } from './Shortcuts'
import { RangeValue } from 'rc-picker/lib/interface'
import { Moment } from 'moment'

type Props = {
  ranges?: RangeValue<Moment>
  setRanges: (values: RangeValue<Moment>) => void
}

export const View: React.FunctionComponent<Props> = ({ ranges, setRanges }) => {
  return (
    <div style={{ display: 'flex', width: '100%' }}>
      <div style={{ flexGrow: 1, marginRight: 15 }}>
        <Picker ranges={ranges} setRanges={setRanges} />
      </div>
      <div style={{ textAlign: 'right' }}>
        <Shortcuts ranges={ranges} setRanges={setRanges} />
      </div>
    </div>
  )
}
